import { makeStyles } from 'tss-react/mui'
import { keyframes } from 'tss-react'

export default makeStyles()({
  container: {
    animation: `${keyframes`
      from {
        transform: scale(0) translateY(-100px),
      }
      to {
        transform: scale(1),
      }
    `} 0.5s cubic-bezier(0.7, 0, 0, 1)`,
    transformOrigin: 'top right',
    position: 'relative',
    overflow: 'visible !important',
    height: 'calc(100% - 24px)',
    boxSizing: 'border-box',
  },
})
